import { AxiosInstance } from "axios";
import { TypeLevel1Entity, UserEntity } from "../../domain/entities";
import { ModelClient } from "../ModelClient";
import { TypeLevel1Stat } from "../../domain/types/TypeLevel";

export class TypeLevel1Client extends ModelClient<TypeLevel1Entity> {

  constructor(apiClient: AxiosInstance) {
    super(apiClient, 'TypeLevel1')
  }
  async import(file: File) {
    const formData = new FormData();
    formData.append("file", file);
    const response = await this.apiClient.post<{ rows: TypeLevel1Entity[] }>("TypeLevel/importFromXlsx", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;

  }
  async getAllWithContractTemplate(language: UserEntity['language']) {
    const response = await this.apiClient.get<{ rows: TypeLevel1Entity[] }>("TypeLevel/withContractTemplate", {
      params: { language }
    });
    return response.data;
  };
  async getAllWithContractAIForm(language: UserEntity['language']) {
    const response = await this.apiClient.get<{ rows: TypeLevel1Entity[] }>("TypeLevel/withContractAIForm", {
      params: { language }
    });
    return response.data;
  };

  async getAllWithFormTemplate(language: UserEntity['language']) {
    const response = await this.apiClient.get<{ rows: TypeLevel1Entity[] }>("TypeLevel/withFormTemplate", {
      params: { language }
    });
    return response.data;
  };
  async getAllWithProjectTemplate() {
    const response = await this.apiClient.get<{ rows: TypeLevel1Entity[] }>("TypeLevel/withProjectTemplate");
    return response.data;
  };
  async getStats() {
    const response = await this.apiClient.get<{ rows: TypeLevel1Stat[] }>(`TypeLevel/stats`);
    return response.data;
  };
  async export() {
    try {
      const response = await this.apiClient.get<{ url: string }>("TypeLevel/exportToXlsx");
      return response.data;
    } catch (error) {
      console.error(`Error exporting types`, error);
      return null;
    }
  };
  async users(typeLevelId:number){
    try{
      const response = await this.apiClient.get<{ rows: any[] }>(`TypeLevel/users`, {
        params: {
          typeLevelId,
        },
      });  
      return response.data;
    }catch(error){
      console.error(`Error`, error);
      return null;
    }
  }
  async assignTypeLevelToUser(typeLevelId:number,email:string){
    try{
      const response = await this.apiClient.post<{ rows: any[] }>(`TypeLevel/assignTypeLevelToUser`, {
          typeLevelId,
          email
      });  
      if (response.status === 200) {
        return { success: true, message: "User successfully added." };
      } else if (response.status === 400) {
        return { success: false, message: "Bad request. Please check the data provided." };
      } else {
        return { success: false, message: "An unexpected error occurred." };
      }
    }catch(error){
      console.error(`Error`, error);
      return null;
    }
  }
  async removeTypeLevelUserAssociation(typeLevelId:number,userId:string){
    try{
      const response = await this.apiClient.post<{ rows: any[] }>(`TypeLevel/removeTypeLevelUserAssociation`, {
        typeLevelId,
        userId,
      });  
      return response.data;
    }catch(error){
      console.error(`Error`, error);
      return null;
    }
  }
}